/*
 * $Id:: ClickableCard.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as LaunchIcon } from '../../assets/images/launch_24px.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    clickableCard: {
        background: '#FFFFFF',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.04)',
        borderRadius: '2px',
        width: '281px',
        height: 'fit-content',
        margin: '20px 30px 0 0',
        padding: '10px 24px',
        position: 'relative',
        '&:hover': {
            cursor: 'pointer',
        },
        '@media (max-width:960px)': {
            width: '200px',
        },
        '@media (max-width:400px)': {
            width: '100%',
        },
        '&$readOnly': { cursor: 'not-allowed' },
    },
    readOnly: {},
    title: {
        fontWeight: 'bold',
        fontSize: '10px',
        lineHeight: '15px',
        textTransform: 'uppercase',
        color: theme.palette.text.label,
    },
    description: {
        fontSize: '14px',
        lineHeight: '20px',
        color: theme.palette.text.tableValue,
        margin: '5px 0 8px 0',
    },
    externalPathIcon: {
        textAlign: 'right',
    },
}));

const ClickableCard = ({ readOnly, item = {}, navigateTo }) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            {Object.keys(item).length > 0 && (
                <div
                    id={`card-${item.title.replace('.', '-')}`}
                    className={[classes.clickableCard, readOnly && !!item.path && !!item.externalPath ? classes.readOnly : ''].join(' ')}
                    onClick={(e) => navigateTo(e, item.path, item.externalPath, item.requiredProfileDetails)}>
                    {item.title && <div className={classes.title}>{t(item.title)}</div>}
                    {item.description && <div className={classes.description}>{t(item.description)}</div>}
                    {item.externalPath && (
                        <div className={classes.externalPathIcon}>
                            <LaunchIcon />
                        </div>
                    )}
                </div>
            )}
        </React.Fragment>
    );
};

export default ClickableCard;
